/**
 * Editorial marquee strip — sits between hero and first content block,
 * transitioning visually from the dark hero illustration to the light
 * parchment body while keeping the premium magazine vibe.
 */
export const EditorialStrip = () => {
    const items = [
        "Экспертная поддержка",
        "Вернуть контроль",
        "Запуск отдела разработки",
        "B2B · РФ и США",
        "Карта результата",
    ];
    return (
        <div
            data-testid="editorial-strip"
            className="relative bg-[#F4F1EA] border-b border-[#1B2A41]/15 py-5 overflow-hidden"
        >
            <div className="vnutri-marquee-track flex whitespace-nowrap text-[#1B2A41]/60 text-[11px] tracking-[0.4em] uppercase font-semibold">
                {Array.from({ length: 2 }).map((_, i) => (
                    <div key={i} className="flex items-center shrink-0">
                        {items.map((it, j) => (
                            <span key={j} className="flex items-center">
                                <span className="px-8">{it}</span>
                                <span className="text-[#C46342]">◆</span>
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};
